var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1545 10.5427C20.9827 9.88299 20.4767 9.36346 19.8341 9.18714C18.6697 8.8667 13.9999 8.8667 13.9999 8.8667C13.9999 8.8667 9.33006 8.8667 8.16552 9.18714C7.52296 9.36346 7.01692 9.88299 6.84519 10.5427C6.5332 11.7385 6.5332 14.2334 6.5332 14.2334C6.5332 14.2334 6.5332 16.7282 6.84519 17.924C7.01692 18.5837 7.52296 19.1033 8.16552 19.2797C9.33006 19.6 13.9999 19.6 13.9999 19.6C13.9999 19.6 18.6697 19.6 19.8341 19.2797C20.4767 19.1033 20.9827 18.5837 21.1545 17.924C21.4665 16.7282 21.4665 14.2334 21.4665 14.2334C21.4665 14.2334 21.4665 11.7385 21.1545 10.5427",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6001 16.8V12.1333L16.3334 14.4667L12.6001 16.8Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/Youtube.7d3f0dac565ae448d0c515081e962188.svg";
export { ForwardRef as ReactComponent };